import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/network/(pages)/(list)')({
  component: lazyRouteComponent(
    () => import('../../-components/NetworkLayout'),
    'NetworkLayout',
  ),
});
